var _defs, _rect, _rect2, _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlexelaQrApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 100,
    r: 5,
    transform: "rotate(0,10,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 115v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,10,120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 125v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,10,130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 145v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,10,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,10,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,10,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,10,180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 185v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,10,190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 205v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,10,210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15 85v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,20,90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15 105v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,20,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,20,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,20,130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15 135v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,20,140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15 155v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,20,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,20,170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15 175v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,20,180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15 195v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,20,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,20,210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 85v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,30,90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 95v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,30,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 125v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,30,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 150,
    r: 5,
    transform: "rotate(0,30,150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 165v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,30,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,30,210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35 95v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,40,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35 105v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,40,110)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 140,
    r: 5,
    transform: "rotate(0,40,140)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 160,
    r: 5,
    transform: "rotate(0,40,160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35 175v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,40,180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35 195v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,40,200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35 205v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,40,210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 105v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,50,110)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 130,
    r: 5,
    transform: "rotate(0,50,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 150,
    r: 5,
    transform: "rotate(0,50,150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 165v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,50,170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 175v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,50,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,50,200)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 120,
    r: 5,
    transform: "rotate(0,60,120)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 140,
    r: 5,
    transform: "rotate(0,60,140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 155v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,60,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,60,170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 195v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,60,200)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 90,
    r: 5,
    transform: "rotate(0,70,90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65 105v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,70,110)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 130,
    r: 5,
    transform: "rotate(0,70,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 150,
    r: 5,
    transform: "rotate(0,70,150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65 165v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,70,170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65 185v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,70,190)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 210,
    r: 5,
    transform: "rotate(0,70,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,80,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75 175v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,80,180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75 185v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,80,190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85 15v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,90,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,90,30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85 35v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,90,40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85 55v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,90,60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85 65v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,90,70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85 105v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,90,110)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 210,
    r: 5,
    transform: "rotate(0,90,210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85 265v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,90,270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85 275v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,90,280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 95 5v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,100,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,100,20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 95 35v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,100,40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 95 45v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,100,50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 95 175v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,100,180)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 220,
    r: 5,
    transform: "rotate(0,100,220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 95 245v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,100,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,100,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 95 265v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,100,270)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 290,
    r: 5,
    transform: "rotate(0,100,290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 105 5v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,110,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,110,20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 105 25v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,110,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,110,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,110,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,110,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,110,80)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 105 85v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,110,90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 105 175v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,110,180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 105 185v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,110,190)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 230,
    r: 5,
    transform: "rotate(0,110,230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 105 245v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,110,250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 105 255v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,110,260)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 280,
    r: 5,
    transform: "rotate(0,110,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,120,20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 115 45v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,120,50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 115 75v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,120,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,120,90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 115 95v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,120,100)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 5,
    transform: "rotate(0,120,120)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 200,
    r: 5,
    transform: "rotate(0,120,200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 115 235v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,120,240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 115 285v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,120,290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 5v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,130,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,130,20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 25v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,130,30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 55v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,130,60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 65v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,130,70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 85v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,130,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,130,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 105v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,130,110)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 180,
    r: 5,
    transform: "rotate(0,130,180)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 220,
    r: 5,
    transform: "rotate(0,130,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,130,240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 255v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,130,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,130,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,130,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,130,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,140,10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 135 35v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,140,40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 135 45v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,140,50)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 80,
    r: 5,
    transform: "rotate(0,140,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,140,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 135 195v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,140,200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 135 225v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,140,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,140,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,140,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 135 265v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,140,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,140,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,150,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,150,20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 145 25v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,150,30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 145 45v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,150,50)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 70,
    r: 5,
    transform: "rotate(0,150,70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 145 85v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,150,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,150,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 145 175v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,150,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,150,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,150,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,150,210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 145 215v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,150,220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 145 235v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,150,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,150,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,150,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 145 285v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,150,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,160,10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 155 15v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,160,20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 155 55v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,160,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,160,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,160,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,160,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,160,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,160,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,160,220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 155 225v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,160,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,160,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,160,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 165 5v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,170,10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 165 35v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,170,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,170,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,170,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,170,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,170,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,170,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,170,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,170,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 165 115v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,170,120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 165 175v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,170,180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 165 185v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,170,190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 165 205v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,170,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,170,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,170,230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 165 245v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,170,250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 165 255v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,170,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 165 275v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,170,280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 165 285v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,170,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,180,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,180,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 175 195v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,180,200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 175 205v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,180,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,180,230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 175 235v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,180,240)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 10,
    r: 5,
    transform: "rotate(0,190,10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185 25v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,190,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,190,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,190,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,190,60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185 65v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,190,70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185 95v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,190,100)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 120,
    r: 5,
    transform: "rotate(0,190,120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185 185v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,190,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,190,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,190,230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185 245v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,190,250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185 255v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,190,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 25v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,200,30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 45v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,200,50)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 90,
    r: 5,
    transform: "rotate(0,200,90)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 110,
    r: 5,
    transform: "rotate(0,200,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 175v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,200,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,200,190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 195v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,200,200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 215v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,200,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,200,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,200,250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 265v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,200,270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 285v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,200,290)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 20,
    r: 5,
    transform: "rotate(0,210,20)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 40,
    r: 5,
    transform: "rotate(0,210,40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 205 65v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,210,70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 205 75v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,210,80)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 100,
    r: 5,
    transform: "rotate(0,210,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 205 175v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,210,180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 205 205v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,210,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,210,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,210,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,210,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,210,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,210,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,210,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,210,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,210,290)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 90,
    r: 5,
    transform: "rotate(0,220,90)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 190,
    r: 5,
    transform: "rotate(0,220,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,220,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,220,250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 215 255v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,220,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,220,280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 215 285v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,220,290)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 110,
    r: 5,
    transform: "rotate(0,230,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 225 135v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,230,140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 225 145v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,230,150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 225 165v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,230,170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 225 175v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,230,180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 225 195v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,230,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,230,210)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 230,
    r: 5,
    transform: "rotate(0,230,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,230,250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 225 265v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,230,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,230,280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 235 85v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,240,90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 235 95v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,240,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 235 135v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,240,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,240,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,240,160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 235 165v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,240,170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 235 185v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,240,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,240,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,240,250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 235 275v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,240,280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 245 95v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,250,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 245 125v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,250,130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 245 155v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,250,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,250,190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 245 205v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,250,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,250,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,250,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,250,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,250,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,250,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 245 265v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,250,270)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 290,
    r: 5,
    transform: "rotate(0,250,290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 255 85v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,260,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,260,130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 255 165v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,260,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,260,190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 255 195v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,260,200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 255 245v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,260,250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 255 255v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,260,260)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 280,
    r: 5,
    transform: "rotate(0,260,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,270,90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 265 95v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,270,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,270,130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 265 135v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,270,140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 265 155v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,270,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,270,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,270,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,270,190)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 210,
    r: 5,
    transform: "rotate(0,270,210)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 240,
    r: 5,
    transform: "rotate(0,270,240)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 270,
    r: 5,
    transform: "rotate(0,270,270)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 290,
    r: 5,
    transform: "rotate(0,270,290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 275 85v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,280,90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 275 105v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,280,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,280,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,280,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 150,
    r: 5,
    transform: "rotate(0,280,150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 275 165v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,280,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,280,190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 275 195v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,280,200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 275 215v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,280,220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 275 245v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,280,250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 275 255v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(90,280,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 275 275v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(180,280,280)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 100,
    r: 5,
    transform: "rotate(0,290,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285 115v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,290,120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285 125v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,290,130)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 160,
    r: 5,
    transform: "rotate(0,290,160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285 185v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,290,190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285 205v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(-90,290,210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285 215v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,290,220)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 240,
    r: 5,
    transform: "rotate(0,290,240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285 275v 10h 5a 5 5, 0, 0, 0, 0 -10",
    transform: "rotate(0,290,280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 5v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,10,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,10,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,10,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,10,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,10,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,10,60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 65v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,10,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,20,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,20,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,30,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,30,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,40,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,40,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,50,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,50,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,60,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,60,70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65 5v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,70,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,70,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,70,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,70,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,70,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,70,60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65 65v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,70,70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 25v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,30,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,30,40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 45v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,30,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,40,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,40,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,40,50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 25v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,50,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,50,40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 45v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,50,50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 225 5v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,230,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,230,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,230,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,230,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,230,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,230,60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 225 65v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,230,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,240,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,240,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,250,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,250,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,260,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,260,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,270,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,270,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,280,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,280,70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285 5v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,290,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,290,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,290,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,290,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,290,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,290,60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285 65v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,290,70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 245 25v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,250,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,250,40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 245 45v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,250,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,260,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,260,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,260,50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 265 25v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,270,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,270,40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 265 45v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,270,50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 225v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,10,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,10,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,10,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,10,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,10,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,10,280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 285v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,10,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,20,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,20,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,30,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,30,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,40,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,40,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,50,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,50,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,60,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,60,290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65 225v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,70,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,70,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,70,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,70,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,70,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,70,280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65 285v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,70,290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 245v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,30,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,30,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 265v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(180,30,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,40,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,40,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,40,270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 245v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(0,50,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,50,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 265v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,50,270)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 300,
    width: 300,
    clipPath: "url('#clip-path-background-color')",
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 300,
    width: 300,
    clipPath: "url('#clip-path-dot-color')",
    fill: "#0F0F0F"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 76,
    y: 134,
    width: "148px",
    height: "32px",
    href: "data:image/svg+xml;base64,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"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlexelaQrApp);
export default __webpack_public_path__ + "static/media/alexela-qr-app.f373415e9b1ea1c2a85912e890b9b17a.svg";
export { ForwardRef as ReactComponent };